import React from 'react';
import Food from '../../../images/Food-Vally.png';
import Shohoz_Sheva from '../../../images/Shohoz-sebha .png';
import town from '../../../images/City-Ride.png';
import world_sport from '../../../images/Favourite-league.png';
import BPL from '../../../images/Draft-Player.png';
import MainProject from '../MainProject/MainProject';



const MainProjectData = () => {

    const projectsData = [
        {
            "projectId": 1,
            "projectName": "Shohoz Sheva",
            "projectDesc": "Responsive MERN Stack project with firebase authentication, admin authentication, persistent login and dashboard functionality for customer and admin User have ability to order available services, check status of order, and provide review. Only admin can update the customer service status from pending to on going to done, add new service with image and add new admin. Sign in is required to register in any service or to view Customer dashboard with services status. Dashboard for user and admin. Authentication (Google) added.",
            "projectImg": Shohoz_Sheva,
            "technology": {
                "t1": "React.js",
                "t2": "Express.js",
                "t3": "Node js",
                "t4": "MongoDB",
                "t5": "Material UI",
                "t6": "Firebase",
                "t7": "Heroku"
            },
            "clientCode": 'https://github.com/Tanjin9185/shohoz-sheva-client',
            "serverCode": 'https://github.com/Tanjin9185/shohoz-sheva-server',
            "liveSite": 'https://shohoz-sebha.web.app/'
        },
        {
            "projectId": 2,
            "projectName": "Food Valley",
            "projectDesc": "A MERN stack application. Responsive for tablet, mobile and PC. User authorization Admin and User. Authentication (Google) added.",
            "projectImg": Food,
            "technology": {
                "t1": "React.js",
                "t2": "Express.js",
                "t3": "Node js",
                "t4": "MongoDB",
                "t5": "React Bootstrap",
                "t6": "Firebase",
                "t7": "Heroku"
            },
            "clientCode": 'https://github.com/Tanjin9185/food-valley-client',
            "serverCode": 'https://github.com/Tanjin9185/food-valley-server',
            "liveSite": 'https://food-valley-2dcb2.web.app/'
        },
        {
            "projectId": 3,
            "projectName": "Town Ride",
            "projectDesc": "A web app where people can hire vehicles. You can see vehicle's total seats and price Login with Google, Facebook, Email & Password You can search by the location where you want to go",
            "projectImg": town,
            "technology": {
                "t1": "React.js",
                "t2": "React Hooks",
                "t3": "Bootstrap 4.5",
                "t4": "React Hook Form",
                "t5": "Material UI",
                "t6": "Google Map API",
                "t7": "Firebase"
            },
            "clientCode": 'https://github.com/Tanjin9185/town-ride',
            "serverCode": 'https://github.com/Tanjin9185?tab=repositories',
            "liveSite": 'https://town-ride.web.app/'
        },
        {
            "projectId": 4,
            "projectName": "world Sport",
            "projectDesc": "This is a cool react app named [world-sport]. The app provides some international football leagues or teams information where you guys can track individual team info like team logo, team banner, team name and so on. The project is created only for skill developing or practice purpose. Let's talk about some features and developing tools of the react application.",
            "projectImg": world_sport,
            "technology": {
                "t1": "React.js",
                "t2": "JavaScript",
                "t3": "HTML5",
                "t4": "CSS3",
                "t5": "Bootstrap 4",
                "t6": "Netlify",
                "t7": ""
            },
            "clientCode": 'https://github.com/Tanjin9185/world-sport',
            "serverCode": 'https://github.com/Tanjin9185?tab=repositories',
            "liveSite": 'https://gifted-northcutt-26848b.netlify.app/'
        },
        {
            "projectId": 5,
            "projectName": "BPL Player Selection",
            "projectDesc": "The app is a simple demonstration of selecting player for premiere league, according to their auction. The league can be football or cricket, in this app people can add their favorite player to their team where player will be selected only one time that means one player can not be selected for the second time. When people add player to the player details cart, the player list will be arranged beautifully, where Selected Player will have there name and auction.",
            "projectImg": BPL,
            "technology": {
                "t1": "React.js",
                "t2": "JavaScript",
                "t3": "HTML5",
                "t4": "CSS3",
                "t5": "Bootstrap 4",
                "t6": "Netlify"
            },
            "clientCode": 'https://github.com/Tanjin9185/draft-player',
            "serverCode": 'https://github.com/Tanjin9185?tab=repositories',
            "liveSite": 'https://condescending-clarke-3be8b6.netlify.app/'
        }
    ]

    return (

        <div className="main-container">
            <div className="row no-gutters">
                <div className="col-md-10 offset-md-1 px-3">
                    <h3 className="heading">Featured Projects</h3>
                    {
                        projectsData.map(project => <MainProject project={project}></MainProject>)
                    }
                </div>
            </div>
        </div>
    );
};

export default MainProjectData;